// extracted by mini-css-extract-plugin
module.exports = {"modal-subheader":"modal-subheader__modal-subheader___2dM_s"};